export function copyObj<T>(obj: T): T {
  if (obj === null || typeof obj !== "object") {
    return obj; // Return primitives or null directly
  }

  const newObj: any = Array.isArray(obj) ? [] : {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = (obj as any)[key];

      // If the field is an array, create a new array with deep copies of its elements
      if (Array.isArray(value)) {
        newObj[key] = value.map((item) =>
          typeof item === "object" ? copyObj(item) : item
        );
      }
      // If the field is an object, recursively copy
      else if (typeof value === "object") {
        newObj[key] = copyObj(value);
      }
      // Otherwise, directly copy the value
      else {
        newObj[key] = value;
      }
    }
  }

  return newObj as T;
}
